/* eslint-disable no-mixed-operators,no-cond-assign */

export const easeOutQuint = (elapsed, initialValue, amountOfChange, duration) => amountOfChange * ((elapsed = elapsed / duration - 1) * elapsed * elapsed * elapsed * elapsed + 1) + initialValue;

export const easeOutQuad = (elapsed, initialValue, amountOfChange, duration) => -amountOfChange * (elapsed /= duration) * (elapsed - 2) + initialValue;

export const easeInOutQuad = (elapsed, initialValue, amountOfChange, duration) => (((elapsed /= duration / 2) < 1) ? amountOfChange / 2 * elapsed * elapsed + initialValue : -amountOfChange / 2 * ((--elapsed) * (elapsed - 2) - 1) + initialValue);
